import { NextRequest, NextResponse } from 'next/server'
import { and, desc, eq } from 'drizzle-orm'
import { auth } from '@/auth'
import { db } from '@/db'
import { aiArtifacts, tickets } from '@/db/schema'

export async function GET(
  _request: NextRequest,
  { params }: { params: Promise<{ ticketId: string }> },
) {
  const session = await auth()
  if (!session?.user?.id) {
    return NextResponse.json({ error: 'Unauthorized' }, { status: 401 })
  }

  const { ticketId } = await params

  const tenantId = session.user.tenantId
  if (!tenantId) {
    return NextResponse.json({ error: 'Forbidden' }, { status: 403 })
  }

  const [ticket] = await db
    .select({ id: tickets.id, status: tickets.status, submitterId: tickets.submitterId })
    .from(tickets)
    .where(and(eq(tickets.id, ticketId), eq(tickets.tenantId, tenantId)))
    .limit(1)

  if (!ticket) {
    return NextResponse.json({ error: 'Not found' }, { status: 404 })
  }

  if (ticket.submitterId !== session.user.id) {
    return NextResponse.json({ error: 'Forbidden' }, { status: 403 })
  }

  let questions: string[] = []
  if (ticket.status === 'NEEDS_INFO') {
    const [artifact] = await db
      .select({ contentJson: aiArtifacts.contentJson })
      .from(aiArtifacts)
      .where(
        and(
          eq(aiArtifacts.ticketId, ticketId),
          eq(aiArtifacts.artifactType, 'clarification_questions'),
        ),
      )
      .orderBy(desc(aiArtifacts.createdAt))
      .limit(1)

    if (artifact?.contentJson) {
      const parsed = JSON.parse(artifact.contentJson) as { questions?: string[] }
      questions = parsed.questions ?? []
    }
  }

  return NextResponse.json({ status: ticket.status, questions })
}
